
import React from 'react';
import { Button } from 'react-bootstrap';
import { FaDownload } from 'react-icons/fa';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import "../styles/descrecibo.css"

const DescargaRecibo = ({ recibo, userLegajo }) => {
    const [mes, anio] = recibo.Mes.split('/');
    const legajoFormateado = userLegajo.toString().padStart(4, '0');
    const secuencia = recibo.Secuencia; 
    const fileBase = `${anio}${mes}${secuencia}O${legajoFormateado}`;
    
    // ⚠️ IMPORTANTE: Codificar el mes completo (formato "MM/YYYY")
    // La barra "/" debe codificarse como "%2F" para no romper la URL
    const API_URL = (process.env.REACT_APP_API_URL || 'http://localhost:4004').replace(/\/$/, '');
    const mesEncoded = encodeURIComponent(recibo.Mes);
    const pdfPath = `${API_URL}/api/recibos/${mesEncoded}/${secuencia}/${userLegajo}/pdf`;

    const handleDescarga = async () => {
        try {
            const token = localStorage.getItem('token');
            
            // ✅ SOLUCIÓN PARA iPhone: Abrir ventana ANTES del fetch (de forma síncrona)
            // Esto es necesario porque iOS bloquea window.open() si no se llama directamente en el evento
            const newWindow = window.open('', '_blank');
            
            // Mostrar mensaje de carga mientras se obtiene el PDF
            if (newWindow) {
                newWindow.document.write(`
                  <html>
                    <head>
                      <style>
                        body {
                          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
                          display: flex;
                          justify-content: center;
                          align-items: center;
                          height: 100vh;
                          margin: 0;
                          background: linear-gradient(135deg, #00b4db 0%, #0083b0 100%);
                        }
                        .loader {
                          text-align: center;
                          color: white;
                        }
                        .spinner {
                          border: 4px solid rgba(255, 255, 255, 0.3);
                          border-radius: 50%;
                          border-top: 4px solid white;
                          width: 60px;
                          height: 60px;
                          animation: spin 1s linear infinite;
                          margin: 0 auto 20px;
                        }
                        @keyframes spin {
                          0% { transform: rotate(0deg); }
                          100% { transform: rotate(360deg); }
                        }
                        h2 {
                          font-size: 24px;
                          font-weight: 300;
                          margin: 0;
                        }
                      </style>
                    </head>
                    <body>
                      <div class="loader">
                        <div class="spinner"></div>
                        <h2>📄 Cargando recibo...</h2>
                        <p style="opacity: 0.8; font-size: 14px; margin-top: 10px;">Por favor espere</p>
                      </div>
                    </body>
                  </html>
                `);
            }
            
            // Descargar el PDF
            const response = await fetch(pdfPath, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            
            if (!response.ok) {
                throw new Error('Error al descargar el recibo');
            }
            
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            
            // Redirigir la ventana ya abierta al PDF
            if (newWindow) {
                newWindow.location.href = url;
            } else {
                // Fallback si el popup fue bloqueado: descargar directamente
                const a = document.createElement('a');
                a.href = url;
                a.download = fileBase + '.pdf';
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            }
            
            // Liberar el objeto URL después de un tiempo
            setTimeout(() => window.URL.revokeObjectURL(url), 30000);
            
        } catch (error) {
            console.error('Error al descargar:', error);
            toast.error('❌ Error al descargar el recibo. Por favor, inténtelo de nuevo.', {
                position: 'top-center',
                autoClose: 3000
            });
        }
    };

    return (
        <Button 
            className="btn btn-descargar action-btn"
            size="sm"
            onClick={handleDescarga}
            title="Descargar recibo"
        >
            <FaDownload />
        </Button>
    );
};

export default DescargaRecibo;